import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import forms from './modules/forms'
import auth from './modules/auth'
import attendees from './modules/attendees'
import home from './modules/home'
import speakers from './modules/speakers'
import countdown from './modules/countdown'
import sections from './modules/sections'
import videos from './modules/videos'
import favorites from './modules/favorites'
import partners from './modules/partners'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showMenu: false,
    error403: false,
    error404: false,
    error429: false,
    error500: false,
    utm_params_names: [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ],
  },
  mutations,
  modules: {
    forms,
    attendees,
    auth,
    home,
    speakers,
    countdown,
    sections,
    videos,
    favorites,
    partners,
  },
})
